/* eslint-disable react-refresh/only-export-components */
import { useModal } from "@/components/core/Root/modal-root"
import Icon from "@/components/Icon"
import { Button } from "@/components/ui/button"
import {
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useI18n } from "@/helpers/i18n/use-translation"

const BrowserErrorModal = ({ close }: { close: (value: boolean) => void }) => {
  const { t, tMap } = useI18n()

  return (
    <DialogContent>
      <DialogHeader />
      <DialogBody>
        <div className="flex gap-x-2" data-unmask>
          {/* eslint-disable-next-line better-tailwindcss/enforce-consistent-line-wrapping */}
          <div className="relative mt-1 size-6 rounded-full border bg-danger-100">
            <Icon name="alert" className="absolute inset-0 text-danger-300" />
          </div>
          <div className="flex flex-col gap-y-4">
            <DialogTitle data-unmask className="font-h3-regular">
              {t("global.modals.browserError.title")}
            </DialogTitle>
            <div className="font-body-medium-regular">
              {tMap("global.modals.browserError.text", (text, i) => (
                <p key={i}>{text}</p>
              ))}
            </div>
          </div>
        </div>
      </DialogBody>
      <DialogFooter data-unmask>
        <Button type="button" variant="outline" onClick={() => close(false)}>
          {t("global.button.close")}
        </Button>
      </DialogFooter>
    </DialogContent>
  )
}

const useBrowserErrorModal = () => {
  const { showModal } = useModal()

  const showBrowserErrorModal = async () => {
    await showModal<boolean>((close) => <BrowserErrorModal close={close} />)
  }

  return {
    showBrowserErrorModal,
  }
}

export { useBrowserErrorModal }
